module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Some babies are yanked into the world, kicking and screaming. Others gasp. Others fling open their little arms and grab. Every infant is unique. Every birth, a miracle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel Devon loved being a midwife.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She smiled down at the newborn swaddled in her arms. The baby girl—only two hours old—stared at the winter sunlight outside the cabin window. What would she be when she grew up? Where would she travel? Would she find love? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Good luck with that, sweet girl. I’m still looking.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Returning to the brass bed where the mom lay in a state of euphoric exhaustion, Rachel announced, “She’s seven pounds, six ounces.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Totally healthy? Nothing to worry about?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A nine-point-five on the Apgar scale. You did good, Sarah.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We did. You and me and Jim and…” Sarah frowned. “We still haven’t decided on the baby’s name.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("Voices rose from the downstairs of the two-story log house near Shadow Mountain Lake. Moments ago, someone else had arrived, and Rachel hoped the visitor hadn’t blocked her van in the circular driveway. After guiding Sarah through five hours of labor, aiding in the actual birth and taking another two hours with cleanup and postpartum ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("instruction, Rachel was anxious to get home. “It’s time for me to go. Should I invite whoever is downstairs to come up here?”")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Jim’s mother.” Sarah pushed her hair—still damp from the shower—off her forehead. “I’d like a bit more time alone. Would you mind introducing the baby to her grandma?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My pleasure. If you need anything over the next few days, call the Rocky Mountain Women’s Clinic. I’ll be on vacation, but somebody can help you. And if you really need to talk to me, I can be reached.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah offered a tired smile. “I apologize in advance for anything Jim’s mother might say.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That sounds ominous.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let’s just say there was a reason we didn’t want Katherine here during labor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel descended the staircase and handed the baby girl to her grandmother, who had positioned herself in a rocking chair beside the moss rock fireplace. With her bright red hair and sleek figure, Katherine seemed too young to be a granny.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After a moment of nuzzling the baby, she shot Rachel a glare. “I wasn’t in favor of this, you know. In my day, this wasn’t the way we had babies.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Really? In your day, were babies delivered by stork?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Katherine continued, “Sarah should have been in a hospital. What if there had been complications?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Everything was perfect.” Jim Loughlin reached down and fondly stroked his baby’s rosy cheek. His hands were huge. A big, muscular guy, Jim was a deputy with the Grand County sheriff’s department. “We wanted a home birth, and Rachel had everything under control.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Skeptically, Katherine looked her up and down. “I’m sorry, dear, but you’re so young.”")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thirty-one,” Rachel said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh my, I would have guessed eight years younger. The pixie hairdo is very flattering with your dark hair.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her age and her hairstyle had nothing to do with her qualifications, and Rachel was too tired to be tactful. “If there had been complications, I would have been prepared. My training as a certified nurse-midwife is the equivalent of a master’s degree in nursing. Plus, I was an EMT and ambulance driver. I’m a real good person to have around in any sort of medical emergency.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Katherine didn’t give up. “Have you ever lost a patient?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not as a midwife.” A familiar ache tightened her gut. Rescuing accident victims was a whole other story—one she avoided thinking about.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Leave Rachel alone,” Jim said. “We have something else to worry about. The baby’s name. Which do you like? Caitlyn, Chloe or Cameron?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His mother sat up straight. “Katherine is a nice name. Maybe she’ll have red hair like me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel eased her way toward the door. Her work here was done. “I’m going to grab my coat and head out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jim rushed over and enveloped her in a bear hug. “We love you, Rachel.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Back at you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This had been a satisfying home birth—one she would remember with pleasure. Midwifery was so much happier than emergency medicine. She remembered Katherine’s question. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Have you ever lost a patient?")]), _vm._v(" Though she knew that not everyone was meant to survive, her memories of victims she couldn’t save haunted her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("As she stepped outside onto the porch, she turned up the fur-lined collar of her subzero parka. Vagrant snowflakes melted as they hit her cheeks. She’d already brushed the ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("snow off the windshield and repacked her equipment in the back of the panel van with the Rocky Mountain Women’s Clinic logo on the side. Ready to roll, Rachel got behind the steering wheel and turned on the windshield wipers.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Heavy snow clouds had begun to blot out the sun. The weatherman was predicting a blizzard starting tonight or tomorrow morning. She wanted to hurry home to her condo in Granby, about forty-five minutes away. Skirting around Katherine’s SUV, she drove carefully down the steep driveway to a two-lane road that hadn’t been plowed since early this morning. There were other tire tracks in the snow, but not many.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After a sharp left, she drove a couple hundred yards to a stop sign and feathered the brakes until she came to a complete stop.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From the back of the van, she heard a noise. Something loose rattling around? She turned to look. A man in a black leather jacket and a ski mask moved forward. He pressed the nose of his gun against her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do as I say,” he growled, “and you won’t be hurt.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You. We need a baby doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A second man, also masked, lurked behind him in her van.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The cold muzzle of the gun pushed against her bare skin. The metallic stink of cordite rose to her nostrils. This weapon had been recently fired.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Get out of your seat,” he ordered. “I’m driving.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fighting panic, she gripped the steering wheel. “It’s my van. I’ll drive. Just tell me where we’re going.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From the back, she heard a grumble. “We don’t have time for this.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("The man with the gun reached forward and engaged the ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("emergency brake. “There’s a woman in labor who needs you. Are you going to turn your back on her?”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” she said hesitantly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t want you to know where we’re going. Understand? That’s why you can’t drive.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right. I’ll sit in the back.” Her van was stocked with a number of medical supplies that could be used as weapons—scalpels, scissors, a heavy oxygen tank. “I’ll do what you say. I don’t want any trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Get in the passenger seat.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still thinking about escape, she unfastened her seat belt and changed seats. Her purse was on the floor. If she could get her hands on her cell phone, she could call for help.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man with the gun climbed into the driver’s seat. She noticed that his jeans were stained with blood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His partner took his place between the seats. Roughly, he grabbed her hands and clicked on a set of handcuffs. Using a bandage from her own supplies, he blindfolded her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The van lurched forward. Only a moment later, they stopped. The rear door opened and slammed shut. She assumed that the second man had left. Now might be her best chance to escape; she was still close enough to the cabin to run back there. Jim was a deputy and would know how to help her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She twisted in the passenger seat. Before her fingers touched the door handle, the man in the driver’s seat pulled her shoulders back and wrapped the seat belt across her chest, neatly and effectively securing her into place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who are you?” she demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He said nothing. The van was in motion again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She warned, “You won’t get away with this. There are people who will come after me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("He remained silent, and her tension grew. She’d been ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("lying about people looking for her. Tomorrow was the first day of a week vacation and she’d already called in with the information about Jim and Sarah’s baby. Rachel lived alone; nobody would miss her for a while.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blindfold made her claustrophobic, but if she looked down her nose, she could see her hands, cuffed in her lap. Helpless. Her only weapon was her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She knew that it was important to humanize herself to her captor. If he saw her as a person, he’d be less likely to hurt her. At least, that was what the police advised for victims of kidnap. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Am I a victim?")]), _vm._v(" Damn, she hoped not.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An adrenaline rush hyped her heart rate, but she kept her voice calm. “Please tell me your name.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s Cole,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Cole,” she repeated. “And your friend?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Frank.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Monosyllables didn’t exactly count as a conversation, but it was something. “Listen, Cole. These cuffs are hurting my wrists. I’d really appreciate if you could take them off. I promise I won’t cause trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The cuffs stay. And the blindfold.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please, Cole. You said you didn’t want to hurt me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Though she couldn’t see him, she felt him staring at her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s only one thing you need to know,” he said. “There’s a pregnant woman who needs you. Without your help, she and her baby will die.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As soon as he spoke, she realized that escape wasn’t an option. No matter how much she wanted to run, she couldn’t refuse to help. The fight went out of her. Her eyes squeezed shut behind the blindfold. More than being afraid for her own safety, she feared for the unknown woman and her unborn child.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OLE")]), _vm._v(" M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("C")]), _vm._v("C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LURE CONCENTRATED")]), _vm._v(" on the taillights of Frank Loeb’s car. The route to their hideout was unfamiliar to him and complicated by a couple of switchbacks; he didn’t want to waste time getting lost.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The decision to track down the midwife had been his. It was obvious that Penny wasn’t going to make it without a hell of a lot more medical expertise than he or any of the other three men could provide.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cole glanced at the blindfolded woman in the passenger seat. Her posture erect, she sat as still as a statue. Her fortitude impressed him. When he held the gun on her, she hadn’t burst into tears or pleaded. A sensible woman, he thought. Too bad he couldn’t explain to her that he was one of the good guys.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She cleared her throat. “Has the mother been having contractions?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How far apart?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s hard to tell. She was shot in the left thigh and has been in pain.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t see through the blindfold, but her head turned toward him. “Shot?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A flesh wound. The bullet went straight through, but she lost blood.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She needs a hospital, access to a surgeon, transfusions. My God, her body is probably in shock.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cole couldn’t have agreed more. “She won’t let us take her to a doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You could make her go. You said she was weak.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If she turns herself in at the hospital, she won’t be released. Penny doesn’t want to raise her baby in jail. Can you understand that, Rachel?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How do you know my name?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("In spite of her self-possessed attitude, he heard a note of ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("alarm in her voice. He didn’t want to reveal more information than necessary, but she deserved an explanation.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When I realized that we needed a midwife, I called the women’s clinic and pretended to want a consultation with a midwife. They gave me your name and told me that you were with a woman in labor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But they wouldn’t tell you the patient’s name,” Rachel said. “That’s a breach of confidentiality.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Frank hacked their computer.” The big thug had a sophisticated skill set that almost made up for his tendency toward sadism. “After that, finding the address was easy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When they discovered that Rachel had been sent to the home of Sarah and Jim Loughlin, it seemed like luck was finally on Cole’s side. The cabin was only ten miles away from their hideout.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frank Loeb had wanted to charge inside with guns blazing, but Cole convinced him it was better to move with subtlety and caution. Every law enforcement man and woman in the state of Colorado was already on the lookout for them. They didn’t need more attention.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re the casino robbers,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wish you hadn’t figured that out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d be an idiot not to,” she said. “It’s all over the news. How much did you get away with? A hundred thousand dollars?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Not even half that amount.")]), _vm._v(" “If you’re smart, you won’t mention the casino again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He regretted dragging her into this situation. If Rachel could identify them, she was a threat. There was no way the others would release her unharmed.")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e5125f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426879708_ch01.vue
// module id = 78
// module chunks = 0